import React, { PureComponent } from 'react';
import { Autocomplete } from '@mic3/platform-ui';
import { connect } from 'react-redux';

import { bind } from 'app/utils/decorators/decoratorUtils';
import { debounce } from 'app/utils/utils';
import { ListItemText } from '@mic3/platform-ui';
import { TypeaheadListItem } from 'app/components/organisms/Form/Typeahead/abstract/TypeaheadListItem';

const isValidPositiveInteger = (str) => {
    if (typeof str !== 'string') return false;
    if (!/^\d+$/.test(str)) return false;
    const num = Number(str);
    return Number.isSafeInteger(num) && num > 0;
};

class ProjectionTypeahead extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { options: props.projections?.list || [] };
    }

    componentDidUpdate(prevProps) {
        // If projections took more time to load and component is already mounted then we have to initialize options
        const { list: newList } = this.props.projections;
        const { list: oldList } = prevProps.projections;
        if (newList.length !== oldList?.length) {
            this.setState({ options: newList });
        }
    }

    @bind
    optionTemplate({ srid, description }) {
        return {
            option: (
                <TypeaheadListItem ContainerComponent='div' dense disableGutters>
                    <ListItemText primary={srid || ''} secondary={description || ''} />
                </TypeaheadListItem>
            ),
            label: `${srid} - ${description}`,
        };
    }

    @bind
    @debounce()
    suggest(event) {
        const { list } = this.props.projections;
        const query = event.target.value;
        if (!query) {
            return this.setState({ options: list });
        }
        const isNumber = isValidPositiveInteger(query);
        const options = list.filter(({ srid, description }) =>
            isNumber ? String(srid)?.includes(query) : description?.toLowerCase()?.includes(query?.toLowerCase())
        );
        this.setState({ options });
    }

    render() {
        const { projections, ...typeaheadProps } = this.props; // eslint-disable-line no-unused-vars
        const { options } = this.state;
        return (
            <Autocomplete
                {...typeaheadProps}
                options={options}
                isLoading={projections?.isLoading}
                optionTemplate={this.optionTemplate}
                placeholder={'Select Projection'}
                suggest={this.suggest}
            />
        );
    }
}

export default connect((state) => ({
    projections: state.app.projections,
}))(ProjectionTypeahead);
